import React, { useState } from 'react';
import { X, Star } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface WriteReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  listingTitle: string;
}
export function WriteReviewModal({
  isOpen,
  onClose,
  listingTitle
}: WriteReviewModalProps) {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (rating === 0) {
      alert('Please select a rating');
      return;
    }
    if (reviewText.trim().length < 20) {
      alert('Review must be at least 20 characters');
      return;
    }
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
      setRating(0);
      setReviewText('');
    }, 2000);
  };
  return <>
      <div data-testid="write-review-modal-overlay" className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-918">
        <div data-testid="write-review-modal" className="bg-white border border-gray-300 max-w-lg w-full shadow-lg" data-id="element-919">
          <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-920">
            <h3 data-testid="write-review-modal-title" className="font-bold text-lg" data-id="element-921">
              Write a Review
            </h3>
            <button data-testid="write-review-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-922">
              <X className="w-5 h-5" data-id="element-923" />
            </button>
          </div>

          <form data-testid="write-review-form" onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-924">
            <div data-testid="write-review-listing-info" className="p-3 bg-gray-50 border border-gray-200" data-id="element-925">
              <p className="text-sm text-gray-600" data-id="element-926">Reviewing:</p>
              <p data-testid="write-review-listing-title" className="font-bold" data-id="element-927">
                {listingTitle}
              </p>
            </div>

            {/* Star Rating */}
            <div data-id="element-928">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-929">
                Your Rating
              </label>
              <div data-testid="write-review-star-rating" className="flex gap-2" data-id="element-930">
                {[1, 2, 3, 4, 5].map(star => <button key={star} data-testid={`write-review-star-${star}`} type="button" onMouseEnter={() => setHoveredRating(star)} onMouseLeave={() => setHoveredRating(0)} onClick={() => setRating(star)} className="transition-transform hover:scale-110" data-id="element-931">
                    <Star className={`w-8 h-8 ${star <= (hoveredRating || rating) ? 'fill-yellow-500 text-yellow-500' : 'fill-none text-gray-300'}`} data-id="element-932" />
                  </button>)}
              </div>
              {rating > 0 && <p data-testid="write-review-rating-label" className="text-sm text-gray-500 mt-2" data-id="element-933">
                  {rating === 5 && 'Excellent!'}
                  {rating === 4 && 'Very Good'}
                  {rating === 3 && 'Good'}
                  {rating === 2 && 'Fair'}
                  {rating === 1 && 'Poor'}
                </p>}
            </div>

            {/* Review Text */}
            <div data-id="element-934">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-935">
                Your Review
              </label>
              <textarea data-testid="write-review-text-input" value={reviewText} onChange={e => setReviewText(e.target.value)} placeholder="Share your experience with this property. What did you like or dislike? Was the documentation accurate?" rows={6} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-936" />
              <p data-testid="write-review-char-count" className="text-xs text-gray-500 mt-1" data-id="element-937">
                Minimum 20 characters ({reviewText.length}/20)
              </p>
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-938">
              <button data-testid="write-review-cancel-btn" type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-939">
                Cancel
              </button>
              <button data-testid="write-review-submit-btn" type="submit" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-940">
                Submit Review
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Review Submitted" message="Thank you for your review! It will be published after verification." type="success" data-id="element-941" />
    </>;
}